import request from '@/config/request'

export default {
    searchListCommentTag: function (code) {
        return request({
            url: '/baseinfo/commenttag/searchlistcommenttag',
            method: 'post',
            params: {
                code: code,
            }
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/baseinfo/commenttag.js